export const searchDebounceTime = 200;
export const paginationDebounceTime = 100;
